var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAptos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 82,
    r: 40,
    fill: "#090A0C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4594_7877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.857 68.7904H96.7857C96 68.7904 95.2143 68.4337 94.6429 67.863L91.7857 64.6529C90.9286 63.7255 89.5714 63.6541 88.5714 64.4388L88.3571 64.6529L85.9286 67.435C85.1429 68.3624 83.9286 68.8618 82.7143 68.8618H44.0714C43 72.0006 42.2857 75.3535 42 78.7063H78.5714C79.2143 78.7063 79.8571 78.421 80.2857 77.9929L83.7143 74.4261C84.1429 73.9981 84.7143 73.7127 85.3571 73.7127H85.5C86.1429 73.7127 86.7857 73.9981 87.2143 74.4974L90.0714 77.7076C90.6429 78.3496 91.4286 78.7063 92.2143 78.7063H122C121.714 75.3535 121 72.0006 119.929 68.8618H103.857V68.7904ZM80.4286 88.4795L77.5714 85.2694C76.7143 84.342 75.3571 84.2706 74.3571 85.0553L74.1429 85.2694L71.6429 88.0515C70.8571 88.9789 69.7143 89.4783 68.5 89.4783H42.5714C43.2143 92.9025 44.3571 96.2553 45.8571 99.4655H64.0714C64.7143 99.4655 65.2857 99.1801 65.7857 98.7521L69.2143 95.1852C69.6429 94.7572 70.2143 94.4719 70.8571 94.4719H71C71.6429 94.4719 72.2857 94.7572 72.7143 95.2566L75.5714 98.4668C76.1429 99.1088 76.9286 99.4655 77.7143 99.4655H118.143C119.643 96.3266 120.786 92.9738 121.429 89.4783H82.5714C81.7143 89.4783 80.9286 89.1216 80.4286 88.4795ZM94.4286 57.3765L97.8571 53.8096C98.2857 53.3816 98.8571 53.0962 99.5 53.0962H99.6429C100.286 53.0962 100.929 53.3816 101.357 53.8096L104.214 57.0198C104.786 57.6618 105.571 57.9472 106.357 57.9472H114.071C100.643 40.2555 75.4286 36.76 57.6429 50.1C54.7143 52.3115 52.0714 54.951 49.7857 57.9472H92.7143C93.4286 58.0898 94 57.8045 94.4286 57.3765ZM66.7857 109.31C65.9286 109.31 65.1429 108.953 64.6429 108.383L61.7857 105.172C60.9286 104.245 59.5 104.174 58.5714 105.03L58.4286 105.172L55.9286 107.955C55.1429 108.882 54 109.381 52.7857 109.381H52.6429C67.7143 125.504 93.2143 126.288 109.429 111.093C110.071 110.523 110.643 109.881 111.286 109.239H66.7857V109.31Z",
    fill: "url(#paint0_linear_4594_7877)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4594_7877",
    x: 34,
    y: 40,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.819608 0 0 0 0 0.988235 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4594_7877"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4594_7877",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4594_7877",
    x1: 82,
    y1: 42,
    x2: 82,
    y2: 122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADADAD",
    stopOpacity: 0.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAptos);
export default __webpack_public_path__ + "static/media/aptos.dd19f64b7f481f3dc5c185f6e250d105.svg";
export { ForwardRef as ReactComponent };